import React from 'react';
import { Entry, TravelGuide, VideoGuide } from '@model/contentful';

export interface DestinationPageContextInterface {
  cmsTravelGuides: Array<Entry<TravelGuide>>;
  cmsVideoGuides: Array<Entry<VideoGuide>>;
}

export const DestinationPageContext = React.createContext<DestinationPageContextInterface | null>(null);
